<template>
  <div class="material-shed-wrap" :class="[startTransform?'material-shed-wrap-new':'material-shed-wrap-dis']">
    <div class="title">环保料场</div>
    <div class="basics-info">
      <!-- <div class="info-list">
        <span class="name">排放源点：</span>
        <span class="value">222个</span>
      </div> -->
      <div class="info-list" v-for="(item, index) of basicsInfo" :key="index">
        <span class="name">{{item.primary_type_name}}：</span>
        <span class="value">{{item.count}}台</span>
      </div>
      <div class="product-info">
        <div class="info">
          <span class="name">当前库存量</span>
          <span class="value" v-if="materialStorageList && materialStorageList.length"><span class="kf">{{materialStorageList[0].materialName}} </span><span class="num">{{materialStorageList[0].storage}}吨，</span><span class="jt">{{materialStorageList[1].materialName}}</span> <span class="num">{{materialStorageList[1].storage}}吨</span></span>
        </div>
        <div class="info">
          <span class="name">日消耗量</span>
        </div>
      </div>
    </div>
    <div class="charts-bar"  ref="chart"></div>
    <div class="other-info">
      <div class="info-list">
        <span class="name">当日闭环管理事件：</span>
      </div>
      <div class="product-info">
        <div class="info">
          <span class="name">发生：</span>
          <span class="value">{{factoryProfile.treatmentCount}}项</span>
        </div>
        <div class="info">
          <span class="name">执行率：</span>
           <span class="value">{{factoryProfile.treatmentRate}}</span>
        </div>
      </div>
      <div class="info-list new-product-info">
        <span class="name">最新闭环事件：</span>
      </div>
      <div class="product-info" v-if="alarmInfo">
        <div class="info">
          <span class="name">发生时间：</span>
          <span class="value new-value">{{alarmInfo.warn_time}}</span>
        </div>
         <div class="info">
          <span class="name">事件概述：</span>
          <span class="value new-value">{{alarmInfo.device_name}},{{alarmInfo.eventName}}</span>
        </div>
        <!-- <div class="info">
          <span class="name">事件概述：</span>
          <span class="value new-value"></span>
        </div> -->
      </div>
      <div class="info new-close-event" v-if="!alarmInfo">
        <span class="name"> 暂无事件发生！</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  switchAreaWarn, //开关告警区域
  switchCarCamera, // 切换相机到洗车机
  currentLocationFun, // 获取当前相机位置
  cameraMoveFun, // 相机移动
  switchSingleHL, // 单个设备高亮
} from "@/assets/js/unity3D/shed.js";
import getOptBar from './chartBar.js';
import { unwarp } from '@/utils/tools.js';
export default {
  props: [""],
  data() {
    return {
      chart: null,
       isRoad: window.bmeConfig.isRoad,
      customerId: this.$store.state.customerId,
      dataList: [],
      basicsInfo: [],
      materialStorageList: '',
      factoryProfile: '',
      newCloseEvent: '',
      alarmInfoTip: '',
      alarmInfo: '',
      startTransform: false
    };
  },

  watch: {},

  created() {
    this.findStockyard()
    this.getListData()
    this.getFactoryProfile()
    this.getCurrentAlarm()
    setTimeout(() => {
      this.startTransform = true
    }, 500)
  },

  methods: {
    async getListData() {
      const emissionCompare = CONFIG.requestShed + this.$apiOpt.productionSituation;
      let res = await this.$apiUtils.get(emissionCompare, {
        customerId: this.customerId,
      });
      this.dataList = res.materialConsumptionList || [];
      // console.log("dataList", this.dataList)
      this.materialStorageList = res.materialStorageList || []
      this.getCharts();
    },

    async findStockyard() {
      const emissionCompare = CONFIG.requestShed + this.$apiOpt.findStockyard;
      let res = await this.$apiUtils.get(emissionCompare, {
        customerId: this.customerId,
        shedNo: "42_101",
      });
      this.basicsInfo = res || [];
      // console.log("basicsInfo", this.basicsInfo)
    },

    async getFactoryProfile() {
      const factoryProfile = CONFIG.requestShed + this.$apiOpt.factoryProfile;
      let res = await this.$apiUtils.get(factoryProfile, {
        customerId: this.customerId,
        shedNo: "42_101",
      });
      this.factoryProfile = res || [];
      // console.log("factoryProfile", this.factoryProfile)
    },

    // 获取当前告警
    async getCurrentAlarm() {
      let findWarningAngleUrl =
        CONFIG.requestShed + this.$apiOpt.findWarningAngle;
      let regionNo = await this.$apiUtils.get(findWarningAngleUrl, {
        /*startTime: this.$moment(new Date().getTime() - 3600 * 1000).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        endTime: this.$moment(new Date().getTime()).format(
          "YYYY-MM-DD HH:mm:ss"
        ),*/
        startTime: "2022-05-20 11:13:09",
        endTime: "2022-05-20 21:13:09",
        shedNo: "42_101",
      });
      if (regionNo) {
        this.alarmInfo = regionNo;
        // this.getFindWarnInfo();
      } 
    },

    getCharts() {
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chart);
      }
      let dataObj = { typeId: [], myValue: [], otherValue: [] };
      this.dataList.forEach((item) => {
        dataObj.typeId.push(item.dayTime);
        dataObj.myValue.push(item.materialInfoList[0].weight);
        dataObj.otherValue.push(item.materialInfoList[1].weight);
      });
      // dataObj.typeId = ["CO2", "SO2", "NO2", "颗粒物"];
      // dataObj.myValue = ["1.75", "1.75", "1.75", "1.75"];
      // dataObj.otherValue = ["0.75", "2.75", "1.2", "1.15"];
      unwarp(this.chart).setOption(getOptBar(dataObj));
    },
  },

  beforeUnmount() {},

  unmounted() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
      // clearTimeout(this.setTime1);
    }
  },
};
</script>

<style scoped lang="scss">
.charts-bar {
  height: 231px;
}

.material-shed-wrap {
  width: 505px;
  height: 814px;
  background: url('../menuMod/img/belt_bg.png') no-repeat;
  background-size: 100% 100%;
  // background: #0f1414;
  // box-shadow: 0px 8px 16px 0px rgba(74, 144, 226, 0.31);
  // border-radius: 2px;
  // border: 1px solid #4a90e2;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: -570px;
  padding: 25px 30px;
  overflow-y: auto;
  transition: all 0.8s ease;
  // &::-webkit-scrollbar-thumb {
  //     width: 8px;
  //     background: linear-gradient(180deg, #8bb3ea 0%, #537bd1 100%);
  //     border-radius: 4px;
  //   }
  .title {
    font-size: 32px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 32px;
    letter-spacing: 2px;
    padding-bottom: 10px;
    text-align: center;
    position: relative;
    position: relative;
    &::before {
      content: "";
      height: 2px;
      width: 180px;
      background: #21456d;
      position: absolute;
      top: 47px;
      left: 50%;
      transform: translateX(-50%);
    }
    
  }
  .basics-info, .other-info {
    margin-top: 30px;
    .info-list {
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      .name {
        color: #ADADAD;
      }
      .value {
        color: #FFFFFF;
      }
    }
    .new-product-info {
      margin-top: 10px;
    }
  }

  .product-info {
    margin-top: 5px;
    padding-left: 30px;
    .info {
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      position: relative;
      padding-left: 20px;
      margin-bottom: 3px;
      &::before {
        content: '';
        width: 6px;
        height: 6px;
        background: linear-gradient(180deg, #E1FFCF 0%, #94F86B 100%);
        position: absolute;
        top: 13px;
        left: 0px;
        // transform: translateY(-50%);
        border-radius: 50%;
      }
      .name {
        color: #F4C48F;
        margin-right: 10px;
      }
      .value {
        color: #d3d6d6;
      }
      .new-value {
        display: block;
      }
    }
    .new-close-event {
      margin-top: 10px;
      &::before {
        content: '';
        width: 6px;
        height: 6px;
        background: #47FFDD;
        position: absolute;
        top: 50%;
        left: 0px;
        transform: translateY(-50%);
        border-radius: 50%;
      }
      .name {
        color: #47FFDD;
      }
    }
    .kf {
      color: #8BC9FF;
    }
    .num {
      color: #4BE0FF;
    }
    .jt {
      color: #F5B698;
    }
  }

  .other-info {
    margin-top: 15px;
  }
}

.material-shed-wrap-new {
  right: 300px;
}

.material-shed-wrap-dis {
  right: -600px;
}
</style>